import { render, staticRenderFns } from "./ErrorAlert.vue?vue&type=template&id=5bec3fd5&scoped=true"
import script from "./ErrorAlert.vue?vue&type=script&lang=js"
export * from "./ErrorAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bec3fd5",
  null
  
)

export default component.exports